import React, { useEffect } from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { debouncedTrigger } from './helpers';

type Props = {
    filter: SentenceFilterT;
    setFilter: FlowAnyFunction;
    isPerimeterFilter: boolean | null | undefined;
    shouldDebounce?: boolean;
    inputProps?: TextFieldProps;
};

export default function SimpleValuePicker({
    setFilter,
    filter,
    inputProps = {
        label: '',
        variant: 'standard',
        classes: {},
    },
    shouldDebounce = false,
}: Props): React.ReactElement {
    const [value, setValue] = React.useState(filter.value);

    useEffect(() => {
        setValue(filter.value);
    }, [filter.value]);

    const onChange: React.ChangeEventHandler<
        HTMLInputElement | HTMLTextAreaElement
    > = (e) => {
        setValue(e.target.value);
        return shouldDebounce
            ? debouncedTrigger({ value: e.target.value }, setFilter)
            : setFilter({ value: e.target.value });
    };

    return (
        <TextField
            name="value"
            value={value}
            onChange={(e) => onChange(e)}
            fullWidth={false}
            {...inputProps}
        />
    );
}
